import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.company.item');
import { OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-company-item',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.company.item/view.scss */
:host {
  display: block;
  height: 100%;
}

.company-comment-layout {
  max-width: 1680px !important;
}`],
})
export class PortalLpsysadminCompanyItemComponent implements OnInit, OnChanges {
    constructor(@Inject( Service) public service: Service) { }

    @Input() company_id: any;
    @Input() menu: any;
    @Input() category: any = 'investment';
    @Input() stage: any = '';

    public company: any = null;
    public loadError: string = '';
    private initialized: boolean = false;
    private loadedCompanyId: string = '';
    public quarterReport: any = null;
    public quarterReportModalOpen: boolean = false;
    public companyRequestModalOpen: boolean = false;
    public companyRequestSaving: boolean = false;
    public companyRequestHistoryOpen: boolean = false;
    public companyRequestHistoryLoading: boolean = false;
    public companyRequests: any[] = [];
    public companyRequestForm: any = {};
    public requestTypeOptions: any[] = [
        { key: 'quarter_report', label: '분기보고 요청' },
        { key: 'general', label: '별도 요청' }
    ];

    public statusConfig: any = {
        meeting: { label: '미팅기업', path: 'meeting_company', badge: 'bg-sky-50 text-sky-700' },
        review: { label: '검토기업', path: 'review_company', badge: 'bg-amber-50 text-amber-700' },
        investment: { label: '투자기업', path: 'company', badge: 'bg-blue-50 text-blue-700' },
        exit: { label: '회수기업', path: 'exit_company', badge: 'bg-emerald-50 text-emerald-700' },
        dropped: { label: '드랍기업', path: 'dropped_company', badge: 'bg-zinc-100 text-zinc-700' }
    };

    public transitionMap: any = {
        meeting: ['review', 'dropped'],
        review: ['investment', 'dropped'],
        investment: ['exit', 'dropped'],
        exit: ['review', 'investment'],
        dropped: []
    };

    public async ngOnInit() {
        // page.admin has already completed the shared authentication/service
        // initialization before this child is mounted. Start the primary data
        // request immediately instead of waiting on a second auth refresh.
        this.initialized = true;
        if (!this.menu) this.menu = 'overview';
        await this.load();
    }

    public async ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized || !changes.company_id || changes.company_id.firstChange) return;
        const current = String(this.company_id || '');
        if (!current || current === this.loadedCompanyId) return;
        await this.load();
    }

    public async load() {
        const requestedCompanyId = String(this.company_id || '');
        if (!requestedCompanyId) return;
        this.loadedCompanyId = requestedCompanyId;
        this.loadError = '';
        this.company = null;
        await this.service.render();

        if (this.company_id == "new") {
            this.company = { extra: {}, isnew: true, status: this.category };
            this.quarterReport = null;
            this.quarterReportModalOpen = false;
            await this.service.render();
            return;
        }
        try {
            const { code, data } = await wiz.call("info", { id: this.company_id });
            if (code !== 200 || !data) {
                this.loadError = data?.message || '기업 정보를 불러오지 못했습니다.';
                this.company = { extra: {}, status: this.category, registed_number: this.company_id };
                await this.service.render();
                return;
            }

            // Legacy companies can contain nullable columns.  Normalize the
            // shape before Angular mounts child widgets so one old value cannot
            // abort the entire detail-page render.
            if (!data.status) data.status = this.category;
            if (!data.extra || typeof data.extra !== 'object' || Array.isArray(data.extra)) data.extra = {};
            if (data.extra.contacts != null && !Array.isArray(data.extra.contacts)) data.extra.contacts = [];
            this.company = data;
            if (!this.company.id) this.company.registed_number = this.company_id;

            // Render the company immediately. Quarter-report status is
            // supplementary and must never leave the primary page blank.
            await this.service.render();
            await this.loadQuarterReportStatus();
        } catch (e) {
            console.error('Failed to load company detail', e);
            this.loadError = '기업 정보를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.';
            this.company = { extra: {}, status: this.category, registed_number: this.company_id };
        }
        await this.service.render();
    }

    public async loadQuarterReportStatus() {
        if (!this.company?.id || this.company?.isnew || this.isComplianceOnly()) {
            this.quarterReport = null;
            this.quarterReportModalOpen = false;
            return;
        }
        try {
            const { code, data } = await wiz.call("quarter_report_status", { id: this.company.id });
            if (code === 200 && data.report?.requested) {
                this.quarterReport = data.report;
                this.quarterReportModalOpen = false;
                return;
            }
        } catch (e) {
            console.error('Failed to load quarter report status', e);
        }
        this.quarterReport = null;
        this.quarterReportModalOpen = false;
    }

    public quarterReportData(): any[] {
        return this.quarterReport?.data || [];
    }

    public dataStatusLabel(item: any): string {
        if (item?.is_new) return '입력됨';
        return '미입력';
    }

    public dataStatusClass(item: any): string {
        if (item?.is_new) return 'bg-emerald-50 text-emerald-700';
        return 'bg-red-50 text-red-600';
    }

    public async openQuarterReportModal() {
        this.quarterReportModalOpen = true;
        await this.service.render();
    }

    public async closeQuarterReportModal() {
        this.quarterReportModalOpen = false;
        await this.service.render();
    }

    public currentYear(): number {
        return new Date().getFullYear();
    }

    public currentQuarter(): number {
        return Math.floor(new Date().getMonth() / 3) + 1;
    }

    public resetCompanyRequestForm(requestType: string = 'quarter_report') {
        const year = this.currentYear();
        const quarter = this.currentQuarter();
        this.companyRequestForm = {
            request_type: requestType,
            year,
            quarter,
            title: requestType === 'quarter_report' ? `${year}년 ${quarter}분기 분기보고 요청` : '자료 요청',
            message: '',
            attachments: []
        };
    }

    public async syncCompanyRequestType() {
        const type = this.companyRequestForm.request_type;
        const year = this.companyRequestForm.year || this.currentYear();
        const quarter = this.companyRequestForm.quarter || this.currentQuarter();
        if (type === 'quarter_report') {
            this.companyRequestForm.title = `${year}년 ${quarter}분기 분기보고 요청`;
        } else if (!this.companyRequestForm.title || this.companyRequestForm.title.indexOf('분기보고 요청') >= 0) {
            this.companyRequestForm.title = '자료 요청';
        }
        await this.service.render();
    }

    public async openCompanyRequestModal(requestType: string = 'quarter_report') {
        if (!this.company?.id || this.company?.isnew) return;
        this.resetCompanyRequestForm(requestType);
        this.companyRequestModalOpen = true;
        await this.service.render();
    }

    public async closeCompanyRequestModal() {
        this.companyRequestModalOpen = false;
        await this.service.render();
    }

    public async addRequestAttachment() {
        if (!Array.isArray(this.companyRequestForm.attachments)) this.companyRequestForm.attachments = [];
        this.companyRequestForm.attachments.push({
            title: '',
            name: '',
            url: '',
            upload_status: 'pending'
        });
        await this.service.render();
    }

    public async uploadRequestAttachment() {
        await this.addRequestAttachment();
    }

    public async uploadRequestAttachmentFile(index: number) {
        if (!Array.isArray(this.companyRequestForm.attachments)) return;
        const attachment = this.companyRequestForm.attachments[index];
        if (!attachment) return;

        const files = await this.service.file.select();
        if (!files || files.length === 0) return;
        const file = files[0];

        await this.service.loading.show();
        try {
            attachment.name = file.name;
            attachment.url = '';
            attachment.upload_status = 'uploading';
            await this.service.render();

            const fd = new FormData();
            fd.append('upload', file);
            try {
                const { url } = await this.service.file.upload('/file/upload?mode=company_request', fd, async () => { });
                attachment.url = url;
                attachment.upload_status = 'uploaded';
            } catch (e) {
                attachment.upload_status = 'failed';
            }
        } finally {
            await this.service.loading.hide();
            await this.service.render();
        }
    }

    public async removeRequestAttachment(index: number) {
        if (!Array.isArray(this.companyRequestForm.attachments)) return;
        this.companyRequestForm.attachments.splice(index, 1);
        await this.service.render();
    }

    public async submitCompanyRequest() {
        if (!this.company?.id || this.company?.isnew) return;
        if (!this.companyRequestForm.title) {
            await this.service.alert.error('요청 제목을 입력해 주세요.');
            return;
        }
        const missingAttachmentTitles = (this.companyRequestForm.attachments || []).filter((item: any) => !String(item?.title || '').trim());
        if (missingAttachmentTitles.length > 0) {
            await this.service.alert.error('첨부파일 제목을 입력해 주세요.');
            return;
        }
        const incompleteAttachments = (this.companyRequestForm.attachments || []).filter((item: any) => item.upload_status !== 'uploaded' || !item.url);
        if (incompleteAttachments.length > 0) {
            await this.service.alert.error('업로드가 완료되지 않은 첨부파일이 있습니다.');
            return;
        }

        this.companyRequestSaving = true;
        await this.service.render();
        const { code, data } = await wiz.call('create_company_request', {
            id: this.company.id,
            request_type: this.companyRequestForm.request_type,
            title: this.companyRequestForm.title,
            message: this.companyRequestForm.message || '',
            year: this.companyRequestForm.year || '',
            quarter: this.companyRequestForm.quarter || '',
            attachments: JSON.stringify(this.companyRequestForm.attachments || [])
        });
        this.companyRequestSaving = false;
        if (code !== 200) {
            await this.service.alert.error(data?.message || '요청 등록에 실패했습니다.');
            await this.service.render();
            return;
        }

        this.companyRequestModalOpen = false;
        if (data.report) {
            this.quarterReport = data.report;
            this.quarterReportModalOpen = true;
        } else {
            await this.service.alert.success('요청을 등록했습니다.');
        }
        await this.loadCompanyRequests(false);
        await this.service.render();
    }

    public attachmentTitle(file: any): string {
        return file?.title || file?.name || '첨부파일';
    }

    public attachmentStatusText(file: any): string {
        if (file?.upload_status === 'uploaded') return '업로드 완료';
        if (file?.upload_status === 'uploading') return '업로드 중';
        if (file?.upload_status === 'failed') return '업로드 실패';
        return '파일 미선택';
    }

    public attachmentStatusClass(file: any): string {
        if (file?.upload_status === 'uploaded') return 'bg-emerald-50 text-emerald-700';
        if (file?.upload_status === 'failed') return 'bg-red-50 text-red-600';
        return 'bg-amber-50 text-amber-700';
    }

    public async loadCompanyRequests(showLoading: boolean = true) {
        if (!this.company?.id || this.company?.isnew) return;
        if (showLoading) {
            this.companyRequestHistoryLoading = true;
            await this.service.render();
        }
        const { code, data } = await wiz.call('company_requests', { id: this.company.id });
        this.companyRequestHistoryLoading = false;
        if (code === 200) {
            this.companyRequests = data.rows || [];
        }
        await this.service.render();
    }

    public async openCompanyRequestHistory() {
        this.companyRequestHistoryOpen = true;
        await this.loadCompanyRequests(true);
    }

    public async closeCompanyRequestHistory() {
        this.companyRequestHistoryOpen = false;
        await this.service.render();
    }

    public async alert(message: string, status: string = 'error', cancel: any = false, action: string = '확인') {
        return await this.service.alert.show({
            title: "",
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status
        });
    }

    public linkCompanyMenu(menu: string) {
        if (menu === 'investment' && this.isComplianceOnly()) {
            return this.baseLink(`/${this.company_id}/${menu}/compliance`);
        }
        return this.baseLink(`/${this.company_id}/${menu}`);
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public activeClass(link: string) {
        if (this.isActive(link)) {
            return "group flex gap-x-3 rounded-md bg-zinc-50 py-2 pl-2 pr-3 text-sm font-semibold leading-6 text-blue-600";
        }
        return "group flex gap-x-3 rounded-md py-2 pl-2 pr-3 text-sm font-semibold leading-6 text-zinc-700 hover:bg-zinc-50 hover:text-blue-600";
    }

    public companyStatus(): string {
        return this.company?.status || this.category || 'investment';
    }

    public isReceivedCompany(): boolean {
        return this.companyStatus() === 'received';
    }

    public statusLabel(status: string = ''): string {
        const key = status || this.companyStatus();
        return this.statusConfig[key]?.label || key || '투자기업';
    }

    public statusBadgeClass(status: string = ''): string {
        const key = status || this.companyStatus();
        return this.statusConfig[key]?.badge || 'bg-zinc-100 text-zinc-700';
    }

    public statusActions() {
        if (this.isComplianceOnly()) return [];
        const current = this.companyStatus();
        const targets = this.transitionMap[current] || [];
        return targets.map((status: string) => ({
            status,
            label: this.statusLabel(status)
        }));
    }

    public statusBaseLink(status: string = '') {
        const key = status || this.category || 'investment';
        const path = this.statusConfig[key]?.path || 'company';
        return '/admin/invest/' + path;
    }

    public async changeStatus(target: string) {
        if (!this.company?.id || this.companyStatus() === target) return;
        const label = this.statusLabel(target);
        const confirmed = await this.service.alert.show({
            title: '기업 상태 이동',
            message: `${this.company.company_name || '기업'}을(를) ${label}으로 이동하시겠습니까?`,
            cancel: '취소',
            action: '이동',
            actionBtn: target === 'dropped' ? 'warning' : 'info',
            status: target === 'dropped' ? 'warning' : 'info'
        });
        if (!confirmed) return;

        const { code, data } = await wiz.call('update_status', {
            id: this.company.id,
            status: target
        });
        if (code !== 200) {
            await this.service.alert.error(data?.message || '기업 상태 이동에 실패했습니다.');
            return;
        }

        this.company.status = target;
        this.category = target;
        await this.service.alert.success(`${label}으로 이동했습니다.`);
        await this.service.href(`${this.statusBaseLink(target)}/${this.company.id}/overview`);
    }

    public baseLink(uri: string = '') {
        return this.statusBaseLink(this.companyStatus()) + uri;
    }

    public isAdminUser(): boolean {
        return ['admin', 'super_admin'].includes(this.service.auth?.session?.membership);
    }

    public isComplianceOfficer(): boolean {
        const extra = this.service.auth?.session?.extra || {};
        return !!extra.is_compliance_officer;
    }

    public isComplianceOnly(): boolean {
        return !this.isAdminUser() && this.isComplianceOfficer();
    }
}

export default PortalLpsysadminCompanyItemComponent;